export default "__VITE_ASSET__CdKLvI9V__"